module.exports = __webpack_public_path__ + "static/img/zljs.ecbef861.png";